import React from 'react'
import PropTypes from 'prop-types'

// import css from './styles.js'
import { svgComponents } from 'SvgComponents/buildingIcons'


const SvgIconAmenities = ({ width = 32, height = 32, name, className = 'svg-icon' }) => {
  const IconComponent = svgComponents[name.replace('#icon-', '')] // dynamically picked
  if(IconComponent) {
    return (
      <IconComponent width={width || '100%'} height={height || '100%'} className={className}/>
    )
  }
}


SvgIconAmenities.propTypes = {
  className: PropTypes.string, // .isRequired,
  name: PropTypes.string.isRequired,
  // width: PropTypes.number,
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  // height: PropTypes.number,
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
}


export default SvgIconAmenities
